import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const postDonationActions = makePieActionObjs("post", "donation")

export const postDonationActionTypes = postDonationActions.pieDict
